import { createTheme, alpha } from "@mui/material/styles";

export const adminTheme = createTheme({
    palette: {
        mode: "light",
        primary: { main: "#2563eb" }, // blue premium
        secondary: { main: "#7c3aed" }, // purple
        success: { main: "#16a34a" },
        warning: { main: "#f59e0b" },
        error: { main: "#dc2626" },
        background: {
            default: "#f6f7fb",
            paper: "#ffffff",
        },
        text: {
            primary: "#0b1220",
            secondary: alpha("#0b1220", 0.65),
        },
        divider: alpha("#0b1220", 0.08),
    },
    shape: { borderRadius: 18 },
    typography: {
        fontFamily: ['Inter', 'system-ui', 'Segoe UI', 'Roboto', 'Arial'].join(","),
        h4: { fontWeight: 900, letterSpacing: -0.6 },
        h5: { fontWeight: 900, letterSpacing: -0.4 },
        button: { textTransform: "none", fontWeight: 800 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: `1px solid ${alpha("#0b1220", 0.08)}`,
                    boxShadow: "0 12px 32px rgba(11,18,32,0.08)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 14,
                    paddingInline: 14,
                    paddingBlock: 10,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    fontWeight: 800,
                },
            },
        },
    },
});
